import { useEffect } from 'react';

type KeyboardShortcutOptions = {
    shortcuts: Record<KeyboardEvent['key'], (() => void) | undefined>;
    isActive?: boolean;
};

export const useKeyboardShortcut = ({
    shortcuts = {},
    isActive = true,
}: KeyboardShortcutOptions) => {
    useEffect(() => {
        if (!isActive) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            const activeElement = document.activeElement as HTMLElement | null;

            const isTypingField =
                activeElement?.tagName === 'INPUT' ||
                activeElement?.tagName === 'TEXTAREA' ||
                activeElement?.tagName === 'SELECT' ||
                (activeElement instanceof HTMLElement &&
                    activeElement.isContentEditable);

            if (
                isTypingField &&
                (event.key === 'Backspace' || event.key === 'Delete')
            ) {
                return;
            }

            const action = shortcuts[event.key];

            if (action) {
                event.preventDefault();
                action();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [shortcuts, isActive]);
};
